import {useState} from 'react';
import * as ActionModifiers from '../ActionModifiers';
import * as SearchForAnEntityWithPath from '../utilities/SearchForAnEntityWithPath';
import * as ClickElement from './ClickElement';
import ColorBar from './ColorBar';
import ScaledTemplate from '../Tabs/ScaledTemplate';

function App(props) {

  var isFEOrPU = props.isFEOrPU;
  var insetWidth = props.insetWidth;
  var overallWidth = props.overallWidth;
  var insetHeight = props.insetHeight;
  var width = props.width;
  var height = props.height;
  var templates = props.templates;
  var handleChanges = props.handleChanges;
  var palette = props.palette;
  var changeTab = props.changeTab;

  var colorCombo = props.colorCombo;
  var setColorCombo = props.setColorCombo;
  var customColorRecord = props.customColorRecord;
  var setCustomColorRecord = props.setCustomColorRecord;
  var isShowingCustom = props.isShowingCustom;
  var setIsShowingCustom = props.setIsShowingCustom;
  
  var userNos = props.userNos;
  var currentList = props.currentList;
  var chains = props.chains;

  var expressedWidth = width;
  if (width >= 768){
    expressedWidth = width * 5/12;
  }else{
    expressedWidth = width * 10/12;
  }

  const [counter, setCounter] = useState(0);

  function incrementCounter(){
    setCounter(counter + 1);
  }

  function clickItem(itemSet){
    return function(e){
      var item = itemSet.v;
      var asChanges = SearchForAnEntityWithPath.getASChanges(itemSet, isFEOrPU, currentList, userNos);
      ClickElement.clickFeOrPu(item, asChanges, isFEOrPU, handleChanges, userNos, currentList);
      e.stopPropagation();
    }
  }

  var components = ActionModifiers.getColorComponents(isShowingCustom, customColorRecord, palette, colorCombo);
  var modOptions = [];
//
   var templatesOut = JSON.parse(JSON.stringify(templates)).map((aTemplate, index)=>{

    var cListCleaned = {s:{},oc:{},sc:{},as:aTemplate.as, _g:currentList._g};
    cListCleaned[isFEOrPU] = {'1':aTemplate.v};

    var w = (expressedWidth - 180);
    var h = (expressedWidth - 180) * (insetHeight - 42)/insetWidth;

    var modOptions1 = ActionModifiers.findIssues(cListCleaned, components, 'selectNew', chains, changeTab);
    modOptions = modOptions.concat(modOptions1);

    var inside = <ScaledTemplate chains={chains} overallWidth={overallWidth} w={w} h={h} error={false} whichFEOrPU={{t:isFEOrPU, v:'1'}} currentList={cListCleaned} onClick={clickItem(aTemplate)} offsetTop={0} offsetLeft={0}/>

    var elab = aTemplate.d;
    return <div key={index} className="col-md-5 cardBlockchain col-11" onClick={clickItem(aTemplate)}> <center>
      {inside}{elab}</center>
    </div>  
  })  

   var botHeight = height - 100;
   var cut = 0;
   var styleBar = null;
   if (modOptions.length > 0){
    cut = 200;
    styleBar = <ColorBar colorCombo={colorCombo} setColorCombo={setColorCombo} incrementCounter={incrementCounter}  customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom} modOptions={modOptions} palette={palette} counter={counter} height={botHeight}/>
   }
//
     

  return <table style={{width:width}}><tbody><tr><td style={{verticalAlign:'top',height:botHeight, width:width-cut}}>
          <div className='container py-5' style={{height:botHeight, overflowY:'scroll'}}>
            <div className='row'>
              {templatesOut}
            </div>
          </div>
        </td>
        {styleBar}
        </tr></tbody></table>

}


//
export default App;
